import React from 'react';
import { X } from 'lucide-react';

export default function ShortcutConfirmModal({ item, onConfirm, onCancel }) {
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' || e.key === 'y' || e.key === 'Y') {
      onConfirm();
    } else if (e.key === 'Escape' || e.key === 'n' || e.key === 'N') {
      onCancel();
    }
  };

  React.useEffect(() => {
    document.addEventListener('keydown', handleKeyPress);
    return () => document.removeEventListener('keydown', handleKeyPress);
  }, []);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 animate-scale-in">
        {/* Header */}
        <div className="bg-gradient-to-r from-teal-600 to-teal-700 text-white px-6 py-4 rounded-t-2xl flex justify-between items-center">
          <h3 className="text-lg font-bold">Confirm Add to Cart</h3>
          <button
            onClick={onCancel}
            className="p-1 hover:bg-white hover:bg-opacity-20 rounded-lg transition"
          >
            <X size={20} />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          {/* Item Info */}
          <div className="bg-teal-50 border border-teal-200 rounded-xl p-4 mb-6">
            <h4 className="font-bold text-lg text-teal-900 mb-1">{item.name}</h4>
            <p className="text-sm text-teal-700 mb-2">{item.category}</p>
            <div className="flex items-baseline gap-2">
              <span className="text-2xl font-black text-teal-700">₹{item.price}</span>
              {item.shortcutKey && (
                <span className="bg-amber-500 text-white px-2 py-0.5 rounded text-xs font-bold">
                  #{item.shortcutKey}
                </span>
              )}
            </div>
          </div>

          {/* Question */}
          <p className="text-slate-700 text-center mb-6">
            Add this item to your cart?
          </p>

          {/* Buttons */}
          <div className="flex gap-3">
            <button
              onClick={onCancel}
              className="flex-1 px-4 py-3 bg-slate-100 hover:bg-slate-200 text-slate-700 font-semibold rounded-xl transition-colors border border-slate-300"
            >
              Cancel <span className="text-xs">(ESC/N)</span>
            </button>
            <button
              onClick={onConfirm}
              autoFocus
              className="flex-1 px-4 py-3 bg-teal-600 hover:bg-teal-700 text-white font-bold rounded-xl transition-colors shadow-lg"
            >
              Add to Cart <span className="text-xs">(ENTER/Y)</span>
            </button>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes scale-in {
          from {
            opacity: 0;
            transform: scale(0.9);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
        .animate-scale-in {
          animation: scale-in 0.2s ease-out;
        }
      `}</style>
    </div>
  );
}